import type { CustomerInfo } from '@revenuecat/purchases-capacitor';
import { logAnalyticsEvent } from 'src/modules/analytics/analytics';
import { reportError } from 'src/modules/logs/Sentry';
import {
  getActiveSubscription,
  getCustomerInfoCompat,
  getPurchasesPackages,
} from 'src/modules/purchase/RevenueCat';
import { RevenueCatPlacement } from 'src/modules/purchase/purchase.constants';
import { readStoredItem, writeStoredItem } from 'src/utils/storageManager';

const trialLatchKey = (familyId?: number, originalPurchaseDate?: string | null) =>
  familyId && originalPurchaseDate
    ? `trial_started_latch:${familyId}:${originalPurchaseDate}`
    : undefined;

const isTrialLatched = (key: string): boolean => readStoredItem(key) !== null;

const latchTrial = (key: string) => {
  writeStoredItem(key, '1');
};

export const logPaywallConversion = async (
  productIdentifier: string,
  placement: RevenueCatPlacement,
  customerInfo?: CustomerInfo,
  familyId?: number,
) => {
  try {
    const info = customerInfo ?? (await getCustomerInfoCompat()).customerInfo;
    const rcAppUserId = info.originalAppUserId;
    const activeSubscription = getActiveSubscription(info);
    if (activeSubscription?.periodType === 'TRIAL') {
      const latchKey = trialLatchKey(familyId, activeSubscription.originalPurchaseDate);
      if (latchKey && isTrialLatched(latchKey)) return;
      if (latchKey) latchTrial(latchKey);
      logAnalyticsEvent('trial_started', {
        is_paid: true,
        rc_app_user_id: rcAppUserId,
      });
      return;
    }
    const packages = await getPurchasesPackages(placement);
    const product = packages.find(
      pkg => pkg.product.identifier === productIdentifier,
    )?.product;
    logAnalyticsEvent('purchase', {
      placement,
      product_id: productIdentifier,
      af_revenue: product?.price,
      af_currency: product?.currencyCode,
      rc_app_user_id: rcAppUserId,
    });
  } catch (error) {
    reportError('Failed to log paywall conversion', error);
  }
};
